@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../constants/spacing.module.less';

.modal-description {
  margin: @space-24 @space-0;
}

.modal-body {
  height: auto;
  padding: @space-0 @space-16 @space-16;
}

.validation-options {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: @space-8;
}

.address {
  font-size: 14px;
}

.checklist {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 95%;
  gap: @space-8;
}

.radio-address {
  display: flex;
}

.label-and-radio {
  display: flex;
  flex-direction: column;
  gap: @space-8;
}

.address-radio-button {
  display: flex;
  align-items: center;
  padding: @space-0;
  height: 24px;
}

.address-edit-button {
  font-weight: 500;
  margin: @space-0;
}

.original-address {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: @space-8;
}

.validation-error {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
  height: 100%;
  gap: @space-8;
  margin-top: @space-8;
}

.address-error-label {
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
}
